import { ChangeDetectorRef, Component } from '@angular/core';
import { QuotationService } from './quotation-leader.service';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-quotation-leader',
  standalone: false,
  templateUrl: './quotation-leader.component.html',
  styleUrl: './quotation-leader.component.css'
})
export class QuotationLeaderComponent {

  successMessage = '';
  errorMessage = '';
  languages: any[] = [];

  activeTab = 'all';
  currentPage = 1;
  pageSize = 5;
  activeTabPopup = 1;
  searchText = '';

  Quotation: any[] = [];
  filteredQuotation: any[] = [];

  isEnableSave: boolean = false;
  isEnableUpdate: boolean = false;
  isEnableDelete: boolean = false;

  isModalOpen = false;

  quoteId: number = 0;
  imageUrl: File | null = null;
  isPublish: boolean = false;
  header_en: string = '';
  body_en: string = '';

  header_kh: string = '';
  body_kh: string = '';

  constructor(
    private quotationService: QuotationService,
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.loadLanguages();
    this.loadQuotation("");
  }

  loadLanguages() {

    this.languageService.getAll().subscribe((res: any) => {

      this.languages = res.data.sort(
        (a: any, b: any) => a.languageId - b.languageId
      );

      if (this.languages.length > 0) {
        this.setTab(this.languages[0].code);
      }

    });

  }

  loadQuotation(langCode: string) {

    this.quotationService.getAllQuotation(langCode)
      .subscribe((res: any) => {

        const apiData: any[] = res.data || [];

        this.Quotation = apiData
          .filter(item => item.translations && item.translations.length > 0)
          .flatMap(item =>
            item.translations.map((t: any) => ({
              quoteId: item.quoteId,
              imageUrl: item.imageUrl,
              isPublish: item.isPublish,

              languageCode: t.languageCode,
              languageId: t.languageId,
              header: t.header,
              body: t.body
            }))
          );

        this.filterQuotation("kh"); // use dynamic instead of hardcode "kh"

      });

  }

  filterQuotation(tab: string) {
    const keyword = this.searchText.trim().toLowerCase();
    this.currentPage = 1;

    this.filteredQuotation =
      this.Quotation.filter(quotation => {
        const matchesTab = quotation.languageCode === tab;
        const matchesSearch = !keyword ||
          `${quotation.header ?? ''} ${quotation.body ?? ''} ${quotation.languageCode ?? ''}`
            .toLowerCase()
            .includes(keyword);

        return matchesTab && matchesSearch;
      });

  }

  clearMsg() {
    this.successMessage = '';
    this.errorMessage = '';
  }

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  resetForm() {
    // this.popularDestinationCategoryId = 0;
    // this.nameKh = '';
    // this.nameEn = '';
  }

  addNew() {
    this.visibleButtonControl('Add');
    this.resetForm();
    this.openModal();
  }

  setTab(tab: string) {

    this.activeTab = tab;
    this.currentPage = 1;

    this.filterQuotation(tab);
  }

  setTabPopup(tab: number) {
    this.activeTabPopup = tab;
  }

  getLanguageCount(lang: string): number {

    return this.Quotation.filter(
      r => r.languageCode === lang
    ).length;

  }

  get pagedQuotation(): any[] {

    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;

    let dt = this.filteredQuotation.slice(start, end);

    return dt;

  }

  changePage(page: number) {
    this.currentPage = page;
  }

  totalPages(): number {
    return Math.ceil(
      this.filteredQuotation.length / this.pageSize
    );
  }

  visibleButtonControl(eventName: string) {

    this.isEnableSave = false;
    this.isEnableUpdate = false;
    this.isEnableDelete = false;

    if (eventName === 'Add') { this.isEnableSave = true }
    else if (eventName === 'Edit') { this.isEnableUpdate = true }
    else if (eventName === 'Delete') { this.isEnableDelete = true }

  }

  viewData(id: number, eventName: string) {

    this.visibleButtonControl(eventName);
    this.quoteId = id;

    this.quotationService.getQuotationById(id, "").subscribe({
      next: (res) => {

        if (res.status === "success") {

          let data = res.data;

          this.quoteId = data.quoteId;
          this.imageUrl = data.imageUrl;
          this.isPublish = data.isPublish;

          data.translations.forEach((item: any) => {
            if (item.languageCode === 'kh') {
              this.header_kh = item.header;
              this.body_kh = item.body;
              // this.isEnabled = item.isEnabled;
            } else if (item.languageCode === 'en') {
              this.header_en = item.header;
              this.body_en = item.body;
            }
          });

          this.openModal();
        } else {
          this.errorMessage = res.message;
        }

        setTimeout(() => {
          this.clearMsg();
          this.cdr.detectChanges();
        }, 3000);

      },
      error: (err) => {

        this.errorMessage = "Failed to create language";

        setTimeout(() => {
          this.clearMsg();
          this.cdr.detectChanges();
        }, 3000);

      }
    });

  }

  onFileSelected(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      this.imageUrl = event.target.files[0];
    }
  }

  getQuotationRequest(quoteId?: number): any {  // you can replace 'any' with your QuotationRequest interface if you have one
    return {
      image: this.imageUrl instanceof File ? this.imageUrl : undefined, // optional file upload

      data: {
        quoteId: quoteId, // optional for update
        isPublish: this.isPublish,
        translations: [
          {
            languageId: 1, // Khmer
            header: this.header_kh ?? '',
            body: this.body_kh ?? ''
          },
          {
            languageId: 2, // English
            header: this.header_en ?? '',
            body: this.body_en ?? ''
          }
        ]
      }
    };
  }

  refreshData(status: string, message: string) {

    if (status === "success") {
      this.successMessage = message;
      this.closeModal();
      this.loadQuotation("");
      this.resetForm();
    } else {
      this.errorMessage = message;
    }

    setTimeout(() => {
      this.clearMsg();
      this.cdr.detectChanges();
    }, 3000);

  }

  exceptionData(message: string) {
    this.errorMessage = message;
    setTimeout(() => {
      this.clearMsg();
      this.cdr.detectChanges();
    }, 3000);
  }

  save() {

    const request = this.getQuotationRequest(0);
    this.clearMsg();

    this.quotationService.create(request).subscribe({
      next: (res) => {
        this.refreshData(res.status, res.message);
      },
      error: (err) => {
        this.exceptionData(err);
      }
    });
  }

  update() {

    this.clearMsg();

    const request = this.getQuotationRequest(this.quoteId);

    this.quotationService.update(this.quoteId,request).subscribe({

      next: (res) => {
        this.refreshData(res.status, res.message);
      },
      error: (err) => {
        this.exceptionData(err);
      }

    });

  }

  delete() {

    if (!confirm("Are you sure you want to delete ?")) {
      return;
    }

    this.quotationService.delete(this.quoteId).subscribe({
      next: (res) => {
        this.refreshData(res.status, res.message);
      },
      error: (err) => {
        this.exceptionData(err);
      }
    });

  }

}
